export default __webpack_public_path__ + "static/media/boom.b74f3180.gif";